import React, { useEffect } from "react";

import PageHelmet from "../PageHelmet";

import photo1 from "../../images/photoExhibition1.png";

const New6 = ({ handleHideNew6 }) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <section className="new-5" id="new-5">
      <PageHelmet
        title="Выставка . Галина Левченко."
        description="Выставка коллектива молодых Московских художников. Коллектив существует в формате свободной мастерской."
        keywords="московский художник, художественная выставка, продажа картин, Галина Левченко, молодой художник"
        author="Галина Левченко"
        copyright="Copyright © 2025 Artist Galina Levchenko"
        image={photo1}
        canonicalUrl="https://galinalevchenko.ru/news"
      />
      <div className="new-2__wrapper">
        <p className="new-1__text">
          Выставка «Сердце хранит Победу» посвящена празднованию Дня Великой Победы 9 мая. <br /> <br />Каждая картина отображает образ, соответствующей тематике известных песен военных лет. Создавая уникальную атмосферу выставки, наполненную чувством сопереживания поколению победителей. <br />Таким образом, выставка «Сердце хранит Победу» предлагает посетителям уникальное путешествие сквозь историю, соединяя художественное творчество и музыкальное наследие, способствующее сохранению памяти о великом подвиге нашего народа.
          
        </p>
        <div className="new-2__main">
          <p className="new-2__main-partners">
            На выставке представлены работы художников Творческого объединения «Палитра мастеров»
            <br /> Евгения Сылка
            <br /> Светлана Кутузова
            <br /> Галина Левченко
            <br /> Анна Рынкова
            <br /> Екатерина Тонких
            <br /> Любовь Ерохина
            <br /> Ольга Шишацкая
            <br /> Людмила Скакун
          </p>
          <button className="new-2__btn hover" onClick={handleHideNew6}>
            СВЕРНУТЬ
          </button>
        </div>
      </div>
    </section>
  );
};

export default New6;
